<script>
import VueChartJs from 'vue-chartjs';

export default {
    name: 'SiteEnrollmentChart',

    extends: VueChartJs.Bar,

    props: {
        enrollments: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            chartColors: ['#63666a', '#464e7e', '#a39382', '#563d82', '#8cac89', '#5489a3', '#e06287'],
            chartOptions: {
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        fontFamily: 'Montserrat, sans-serif',
                    },
                },

                hover: { mode: null },

                scales: {
                    yAxes: [{
                        ticks: {
                            precision: 0,
                            beginAtZero: true,
                            suggestedMax: this.calculateSuggestedMax(this.enrollments),
                        },
                    }],

                    xAxes: [{
                        gridLines: {
                            display: false,
                        },

                        ticks: {
                            fontFamily: 'Montserrat, sans-serif',
                        },
                    }],
                },

                tooltips: {
                    enabled: false,
                },

                responsive: true,
                maintainAspectRatio: false,

                plugins: {
                    datalabels: {
                        color: '#000',
                        anchor: 'end',
                        align: 'bottom',
                        offset: -30,
                        font: {
                            size: 16,
                            weight: 'bold',
                        },
                    },
                },
            },
        };
    },

    computed: {
        groups() {
            return [...new Set(this._.map(this.enrollments, (e) => e.group.name))];
        },

        chartData() {
            return {
                labels: this.groups,

                legend: {
                    display: true,
                },

                datasets: this.datasets,
            };
        },

        datasets() {
            return Object.values(this._.groupBy(this.enrollments, 'label')).map((label, index) => ({
                label: label[0].label,
                backgroundColor: this.chartColors[index],
                data: label.map((e) => e.value),
            }));
        },
    },

    watch: {
        chartData() {
            this.updateChart();
        },
    },

    mounted() {
        this.updateChart();
    },

    methods: {
        updateChart() {
            this.renderChart(this.chartData, this.chartOptions);
        },

        calculateSuggestedMax(enrollments) {
            const values = enrollments.map((e) => e.value);

            return Math.max(...values) * 1.1;
        },
    },
};
</script>
